import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ChiSiamo = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">
            {t('pages.about.title')}
          </h1>
          <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto">
            {t('pages.about.subtitle')}
          </p>
        </div>

        <div className="space-y-8 text-gray-300">
          
          <div className="bg-black rounded-xl p-6 md:p-8">
            <h2 className="text-xl md:text-2xl font-semibold text-white mb-6">{t('pages.about.company_name')}</h2>
            
            <div className="space-y-4 text-sm md:text-base leading-relaxed">
              <p>
                <strong className="text-white">{t('pages.about.company_name')}</strong> {t('pages.about.company_description_1')}
              </p>
              <p>{t('pages.about.company_description_2')}</p>
              <p>{t('pages.about.company_description_3')}</p>
            </div>
          </div>

          <div className="bg-black rounded-xl p-6 md:p-8">
            <h2 className="text-xl md:text-2xl font-semibold text-white mb-6">{t('pages.about.beautyou_title')}</h2>
            
            <div className="space-y-4 text-sm md:text-base leading-relaxed">
              <p>{t('pages.about.beautyou_intro')}</p>
              
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-white">{t('pages.about.beautyou_need_1')}</strong></li>
                <li><strong className="text-white">{t('pages.about.beautyou_need_2')}</strong></li>
              </ul>
              
              <p>{t('pages.about.beautyou_description')}</p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-gray-900/30 rounded-lg p-6 text-center">
              <h3 className="text-white font-medium mb-2 text-lg">{t('pages.about.value_1_title')}</h3>
              <p className="text-sm text-gray-400">{t('pages.about.value_1_desc')}</p>
            </div>
            
            <div className="bg-gray-900/30 rounded-lg p-6 text-center">
              <h3 className="text-white font-medium mb-2 text-lg">{t('pages.about.value_2_title')}</h3>
              <p className="text-sm text-gray-400">{t('pages.about.value_2_desc')}</p>
            </div>
            
            <div className="bg-gray-900/30 rounded-lg p-6 text-center">
              <h3 className="text-white font-medium mb-2 text-lg">{t('pages.about.value_3_title')}</h3>
              <p className="text-sm text-gray-400">{t('pages.about.value_3_desc')}</p>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ChiSiamo;
